module.exports = __webpack_public_path__ + "img/img15.149b00ed.jpg";